import React, { createContext, useState, useContext} from 'react';
import { axiosInstance } from '../api/Axios';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});

    const isAuthenticated = !!auth.access;

    const logout = async () => {
        setAuth({});
        localStorage.removeItem('auth');
        try {
            await axiosInstance.get('api/logout/', {
                withCredentials: true
            });
        } catch (error) {
            console.error('Failed to logout:', error);
        }
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, isAuthenticated, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
